module.exports = __webpack_public_path__ + "static/img/img_change_route.6d6a36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_change_route.png
// module id = deJi
// module chunks = 1